export const SPENDING_LIMITS = {
    NONE: 'NONE',
    MONTHLY: 'MONTHLY',
    LIFETIME: 'LIFETIME',
};

export const SPENDING_LIMIT_KEYS = Object.keys(SPENDING_LIMITS);
